import { useMemo } from "react"

import { useStaticQuery, graphql } from "gatsby"
import { useI18next } from "gatsby-plugin-react-i18next"
import styled, { CSSProp } from "styled-components"

import InnerWrapper from "components/InnerWrapper"
import TestimonialsBanner from "components/sectionTemplates/Testimonials"
import colors from "styles/colors"
import text from "styles/text"
import useMedia from "utils/useMedia"

export default function Testimonials() {
  const quoteSize = useMedia<CSSProp>("", "", "", text.h6)
  const { t } = useI18next()

  const testQuote1 = t(
    "Galileo's robust APIs give us the flexibility and agility to create entirely new solutions not contemplated with other issuing processors or B2B virtual card incumbents, with their inflexible legacy systems."
  )
  const kickerQuote = t("INDUSTRY LEADERS LEAN ON GALILEO")

  const testQuote2 = t(
    "With our partnership, Galileo gives us everything we need to be an all-encompassing payments platform for businesses of all sizes—from Main Street to enterprise."
  )

  const images: Queries.BtoBTestimonialsQuery = useStaticQuery(graphql`
    query BtoBTestimonials {
      steve: file(relativePath: { eq: "b2b/steve.webp" }) {
        ...LocalImageQuery
      }
      stephen: file(relativePath: { eq: "b2b/stephen.webp" }) {
        ...LocalImageQuery
      }
      bluePenguin: file(relativePath: { eq: "b2b/bluepenguin.webp" }) {
        ...LocalImageQuery
      }
      globalRewards: file(relativePath: { eq: "b2b/globalRewards.webp" }) {
        ...LocalImageQuery
      }
    }
  `)

  const SteveIMG = images.steve?.childImageSharp?.gatsbyImageData
  const StephenIMG = images.stephen?.childImageSharp?.gatsbyImageData
  const BluePenguinIMG = images.bluePenguin?.childImageSharp?.gatsbyImageData
  const GlobalRewardsIMG =
    images.globalRewards?.childImageSharp?.gatsbyImageData

  const TESTIMONIAL_DATA = useMemo(
    () => [
      {
        kicker: kickerQuote,
        title: `"${testQuote1}"`,
        person: {
          image: SteveIMG,
          name: "Steve Boyer",
          title: "CEO, BluePenguin",
        },
        logo: BluePenguinIMG,
        quoteSize,
      },
      {
        kicker: kickerQuote,
        title: `"${testQuote2}"`,
        person: {
          image: StephenIMG,
          name: "Stephen Schum",
          title: "CEO, Global Rewards",
        },
        logo: GlobalRewardsIMG,
        quoteSize,
      },
    ],
    [
      BluePenguinIMG,
      GlobalRewardsIMG,
      StephenIMG,
      SteveIMG,
      quoteSize,
      testQuote1,
      kickerQuote,
      testQuote2,
    ]
  )

  return (
    <Wrapper>
      <InnerWrapper setWidth={useMedia("1144px", "68.92vw", "100%", "100%")}>
        <TestimonialsBanner
          items={TESTIMONIAL_DATA}
          primaryColor={colors.white}
          secondaryColor={colors.seaFoam100}
        />
      </InnerWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: ${colors.seaFoam800};
  width: 100%;
`
